// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__J-HyF","log":"ModalInventoryLogs_log__3wydI","date":"ModalInventoryLogs_date__1OE-v","userName":"ModalInventoryLogs_userName__30JzM"};